import { z } from 'zod';
import { appFormOptions } from '@/common/form/appFormOptions.ts';
import { requiredInput } from '@/common/form/requiredInput.ts';
import { optionalInput } from '@/common/form/optionalInput.ts';

export const dispenserFormSchema = z.object({
  sn: requiredInput(z.string().max(255)),
  canisters: requiredInput(z.int32().min(1)),
  pos: optionalInput(z.string()).transform((v) => v ?? ''),
  producerId: requiredInput(z.string()).transform(() => undefined), // The value is not used after submission
  typeId: requiredInput(z.string()),
  collectorId: optionalInput(z.string()),
  note: optionalInput(z.string().max(64000)).transform((v) => v ?? ''),
});

export type DispenserFormValues = z.input<typeof dispenserFormSchema>;

export type DispenserFormOutput = z.output<typeof dispenserFormSchema>;

export const DISPENSER_FORM_DEFAULT_VALUES: DispenserFormValues = {
  sn: null,
  canisters: null,
  pos: null,
  producerId: null,
  typeId: null,
  collectorId: null,
  note: null,
};

export const getDispenserFormOptions = (
  initialValues?: DispenserFormValues,
  onSubmit?: (values: DispenserFormOutput) => Promise<unknown>
) =>
  appFormOptions({
    schema: dispenserFormSchema,
    defaultValues: initialValues ?? DISPENSER_FORM_DEFAULT_VALUES,
    onSubmit: ({ value }) => {
      return onSubmit?.(value);
    },
  });
